import { render, staticRenderFns } from "./NotificationsConfigure.vue?vue&type=template&id=63bb7b03&"
import script from "./NotificationsConfigure.vue?vue&type=script&lang=js&"
export * from "./NotificationsConfigure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports